export { AuthClient as ICAuthClient } from "./icAuthClient";
export { IC } from "./icConnect";
